/* ds-rutin-bf.js: az utóápolás-builder (snippets/ds-rutin-bf.liquid), 2026-11-01.
   Előre mutatja azt az árat, amit a kosár automatikus kedvezményei adnak:
   BF rutin n db -> 5/10/15/20/25% a bőrápolókra, VAGY stamp + Centella -1 000 Ft; a kettő közül a nagyobb
   (a Shopify is a vevőnek jobb kombinációt választja, cart.js-sel mérve 11-01). Soronkénti kerekítés, mint a Shopifyé.
   A ds-pick.js a gomb feliratát a saját change-handlerében írja; mi utána futunk (setTimeout 0). */
(function () {
  if (window.__dsRbfLoaded) return;
  window.__dsRbfLoaded = true;
  var PCT = [0, 5, 10, 15, 20, 25];
  /* a bolt `money` formátumát a Liquid mintájából vesszük: data-m1k = 123400 minor a vevő pénznemében
     („1,234 Ft”, „€1.234,00”, „1 234,00 €”): előtag, ezres-elválasztó, tizedes-jel (ha van), utótag.
     2026-11-01 éjjel: minden piac (EUR is); korábban csak forint. */
  var PRE = '', SEP = ',', DEC = '', SUF = ' Ft';
  function huf(minor) {
    var neg = minor < 0, a = Math.abs(minor), whole = DEC ? Math.floor(a / 100) : Math.round(a / 100);
    var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, SEP);
    if (DEC) s += DEC + String(a % 100 + 100).slice(1);
    return (neg ? '-' : '') + PRE + s + SUF;
  }
  function fill(t, o) { return String(t || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }

  function init(r) {
    var pk = r.closest('[data-pk]'), form = r.closest('form');
    var m = (r.dataset.m1k || '').trim().match(/^(\D*)1(\D?)234(?:(\D)00)?(\D*)$/);
    if (m) { PRE = m[1]; SEP = m[2]; DEC = m[3] || ''; SUF = m[4]; }
    var boxes = [].slice.call(r.querySelectorAll('[data-rbf-i]'));
    var bf = r.dataset.bf === '1', cenOff = +r.dataset.cenOff || 0;
    var msg = r.querySelector('[data-rbf-msg]'), steps = r.querySelectorAll('.rbf__steps li');
    var all = r.querySelector('[data-rbf-all]'), allT = r.querySelector('[data-rbf-all-t]');
    var allLabel = allT ? allT.textContent : '';
    var sum = r.querySelector('[data-rbf-sum]');

    /* 2026-11-02 (Marci): csak a TÉNYLEG kiválasztott csomag számít. Választás nélkül nincs „a csomagoddal együtt” sor,
       helyette a „válaszd ki a csomagod” doboz + gomb (felvisz a választóhoz). */
    function card() {
      var i = pk && pk.querySelector('.pk__c input:checked');
      return i ? i.closest('.pk__c') : null;
    }

    /* 2026-11-01 v3: a BF-létra és a Centella -1 000 Ft KOMBINÁLÓDIK (combinesWith.productDiscounts=true mind a kettőn),
       a Shopify soronként a nagyobbat adja, ugyanarra a sorra nem adja össze (cart.js-sel mérve). Ezért: a Centella
       is számít a létrába, a sora max(-1 000 Ft, -p%), a többi sor -p%. Sorrendtől független. */
    /* a -1 000 Ft (BXGY) csak egyszeri stamp mellé indul: előfizetéses stamp mellett a kosár sem adja (mérve 11-01) */
    /* 2026-11-01 este (Marci): a Centella a 4 db mellett is a százalékos létrát kapja; a -1 000 Ft (BXGY) már CSAK a 12-es kúra mellett él */
    /* Marci 11-01 este: a Centella MINDENHOL a százalékos létrát kapja (a kúra mellett is); a BXGY-t publikáláskor ki kell kapcsolni */
    function cenOk() { return false; }
    function off(b, p) {
      /* a Shopify a darabonkénti kedvezményt fél egységnél LEFELÉ kerekíti (EUR-ban mérve 11-02: 4,50 € -15% = 0,675 → 0,67,
         ár 3,83; 6,50 € → 0,97). Math.round felfelé vitte volna (3,82). A kosár-csempe Liquidje (ár | round) ugyanezt adja. */
      var m = +b.dataset.minor, d = Math.ceil(m * p / 100 - 0.5);
      return (b.dataset.cen && cenOk()) ? Math.max(d, cenOff) : d;
    }
    function render() {
      var on = boxes.filter(function (b) { return b.checked; });
      var n = on.length, pct = bf ? PCT[Math.min(n, 5)] : 0, nextP = bf ? PCT[Math.min(n + 1, 5)] : 0;
      var orig = 0, save = 0;
      on.forEach(function (b) { orig += +b.dataset.minor; save += off(b, pct); });

      boxes.forEach(function (b) {
        var lab = b.closest('[data-rbf-tile]'), was = lab.querySelector('[data-rbf-was]'), now = lab.querySelector('[data-rbf-now]');
        var m = +b.dataset.minor, p = b.checked ? pct : nextP; /* bepipálatlanul: az ár, ha ezt is beteszi */
        var d = off(b, p), byCen = b.dataset.cen && cenOk() && cenOff >= Math.ceil(m * p / 100 - 0.5);
        lab.classList.toggle('is-on', b.checked);
        lab.dataset.price = d > 0 ? huf(m - d) : now.dataset.base;
        was.hidden = d <= 0;
        now.textContent = d > 0 ? huf(m - d) : now.dataset.base;
        var tag = lab.querySelector('[data-rbf-tag]');
        if (tag) { tag.textContent = byCen ? 'BF −' + huf(cenOff) : 'BF −' + p + '%'; tag.hidden = d <= 0; }
        lab.dataset.tag = d > 0 ? tag.textContent : '';
        lab.classList.toggle('has-d', d > 0);
      });

      for (var i = 0; i < steps.length; i++) {
        var sn = +steps[i].dataset.n;
        steps[i].classList.toggle('is-on', n >= sn);
        steps[i].classList.toggle('is-next', sn === Math.min(n + 1, 5) && n < 5);
      }
      if (msg) {
        var t;
        if (!n) t = msg.dataset.m0;
        else if (n >= 5) t = msg.dataset.max;
        else if (n === 4) t = fill(msg.dataset.m1, { p: PCT[5] });
        else t = fill(msg.dataset.m, { p: PCT[n + 1] });
        msg.textContent = t;
      }
      if (allT) {
        var full = n === boxes.length;
        allT.textContent = full ? allT.dataset.on : allLabel;
        all.classList.toggle('is-on', full);
      }

      var c = card(), stamp = c ? +c.dataset.minor : 0;
      var sub = r.querySelector('[data-rbf-sub]'); if (sub) sub.hidden = !(c && c.dataset.k === 'haj');
      sum.hidden = !n;
      var need = r.querySelector('[data-rbf-need]'); if (need) need.hidden = !(n && pk && !c);
      if (n) {
        var l = r.querySelector('[data-rbf-sum-l]'); l.textContent = fill(l.dataset.t, { n: n });
        var w = r.querySelector('[data-rbf-sum-was]'); w.textContent = save > 0 ? huf(orig) : ''; w.hidden = !(save > 0);
        r.querySelector('[data-rbf-sum-now]').textContent = huf(orig - save);
        var s = r.querySelector('[data-rbf-save]'); s.textContent = save > 0 ? fill(s.dataset.t, { price: huf(save) }) : ''; s.hidden = !(save > 0);
        var tt = r.querySelector('[data-rbf-tot]'), isSub = c && c.dataset.k === 'haj';
        /* előfizetésnél csak a csomag ismétlődik, a bőrápolók egyszeriek: a ma fizetendőt és az ismétlődőt külön mondjuk */
        tt.textContent = !stamp ? '' : isSub ? fill(tt.dataset.ts, { price: huf(stamp + orig - save), sub: c.dataset.price }) : fill(tt.dataset.t, { price: huf(stamp + orig - save) });
        tt.hidden = !stamp;
      }
      /* a ds-pick gombja „Kosárba · <ár>”: a teljes összeget mutassa */
      var btn = form && form.querySelector('[type="submit"]');
      if (btn && !btn.disabled && c && n) btn.textContent = (c.dataset.cta || btn.textContent.split(' · ')[0]) + ' · ' + (c.dataset.k === 'haj' ? r.dataset.today + ' ' : '') + huf(stamp + orig - save);
    }

    var ib = r.querySelector('.rbf__i'), ip = r.querySelector('.rbf__info');
    if (ib && ip) ib.addEventListener('click', function (e) {
      e.preventDefault(); var open = ip.hidden; ip.hidden = !open; ib.setAttribute('aria-expanded', String(open));
    });
    var later = function () { setTimeout(render, 0); };

    /* infó-ablak: a csempe képe/neve nyitja; a gombja ugyanazt a pipát kapcsolja, mint a plusz */
    var dlg = r.querySelector('[data-rbf-dlg]'), cur = null;
    function dlgSync() {
      if (!cur || !dlg) return;
      var b = cur.querySelector('[data-rbf-i]'), add = dlg.querySelector('[data-rbf-dlg-add]');
      add.textContent = b.checked ? add.dataset.tRm : add.dataset.tAdd + ' +';
      add.classList.toggle('is-on', b.checked);
      dlg.querySelector('[data-rbf-dlg-p]').innerHTML = (cur.dataset.tag ? '<em class="rbf__dlg-tag"></em>' : '') + '<b class="rbf__dlg-now"></b>';
      if (cur.dataset.tag) dlg.querySelector('.rbf__dlg-tag').textContent = cur.dataset.tag;
      dlg.querySelector('.rbf__dlg-now').textContent = cur.dataset.price || '';
    }
    function dlgOpen(t) {
      if (!dlg) return; cur = t;
      dlg.style.setProperty('--c', t.style.getPropertyValue('--c'));
      var img = t.querySelector('.rbf__img img');
      dlg.querySelector('[data-rbf-dlg-img]').innerHTML = img ? '<img src="' + img.currentSrc.replace(/"/g, '') + '" alt="">' : '';
      dlg.querySelector('[data-rbf-dlg-c]').innerHTML = t.querySelector('[data-rbf-pi]').innerHTML;
      dlgSync();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      document.documentElement.classList.add('rbf-lock');
    }
    function dlgClose() { if (!dlg) return; if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
    if (dlg) {
      dlg.addEventListener('close', function () { document.documentElement.classList.remove('rbf-lock'); cur = null; });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlgClose(); }); /* háttérre koppintás = bezár */
      dlg.querySelector('[data-rbf-dlg-x]').addEventListener('click', dlgClose);
      dlg.querySelector('[data-rbf-dlg-add]').addEventListener('click', function () {
        if (!cur) return; var b = cur.querySelector('[data-rbf-i]'), was = b.checked;
        b.checked = !was; b.dispatchEvent(new Event('change', { bubbles: true }));
        if (!was) { setTimeout(dlgClose, 120); } else { setTimeout(dlgSync, 10); }
      });
    }
    [].forEach.call(r.querySelectorAll('[data-rbf-open]'), function (o) {
      o.addEventListener('click', function (e) { e.preventDefault(); dlgOpen(o.closest('[data-rbf-tile]')); });
    });
    var nb = r.querySelector('[data-rbf-need-b]');
    if (nb) nb.addEventListener('click', function () {
      var t = pk && (pk.querySelector('.pk__fs') || pk);
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    (pk || r).addEventListener('change', later);
    if (all) all.addEventListener('click', function () {
      var full = boxes.every(function (b) { return b.checked; });
      boxes.forEach(function (b) { b.checked = !full; });
      later();
    });
    later();
  }

  function boot() { document.querySelectorAll('[data-rbf]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
